<template>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="259.211px" height="259.211px" viewBox="0 0 259.211 259.211" style="enable-background:new 0 0 259.211 259.211;"
	 xml:space="preserve">
<g>
	<path d="M58.002,41.943C59.72,54.458,70.454,64.14,83.434,64.14c14.168,0,25.693-11.529,25.693-25.701
		c0-14.167-11.525-25.697-25.693-25.697c-12.98,0-23.714,9.68-25.432,22.193h-2.76c-1.935,0-3.504,1.571-3.504,3.504
		c0,1.936,1.569,3.504,3.504,3.504H58.002z M83.434,57.131c-9.104,0-16.688-6.552-18.334-15.188h36.665
		C100.114,50.58,92.534,57.131,83.434,57.131z M83.434,19.751c9.103,0,16.683,6.553,18.331,15.184H65.1
		C66.746,26.304,74.326,19.751,83.434,19.751z"/>
	<path d="M172.121,148.52l36.258,36.261c0.685,0.682,1.582,1.027,2.479,1.027s1.796-0.346,2.478-1.027l44.851-44.851
		c0.66-0.657,1.026-1.547,1.026-2.478c0-0.928-0.366-1.82-1.026-2.478l-21.303-21.301c0-0.003,0-0.007-0.007-0.01
		c-0.004-0.003-0.007-0.003-0.011-0.007l-14.941-14.943c-1.313-1.314-3.641-1.314-4.955,0l-18.729,18.726
		c0.151-0.82,0.254-1.653,0.254-2.512c0-4.444-2.026-8.561-5.466-11.229l-32.695-27.151c-2.125-2.221-4.91-3.701-7.919-4.211
		c-0.112-0.043-0.222-0.079-0.346-0.106L116.3,63.075c-2.792-1.283-5.774-2.043-8.87-2.26c-0.269-0.05-0.536-0.06-0.809-0.05
		c-0.332-0.021-0.666-0.039-1.004-0.039c-9,0-17.414,4.791-22.046,12.521l-15.976,21.05L39.28,87.224
		c-0.529-0.173-2.45-0.621-2.45-0.621c-0.385-0.087-0.777-0.113-1.152-0.063c-3.55-0.221-6.844,0.975-9.479,3.01V76.826
		c3.066-2.919,4.792-6.911,4.792-11.196c0-5.744-3.153-10.983-8.227-13.682c-1.09-0.579-2.397-0.542-3.449,0.092
		c-1.054,0.633-1.699,1.773-1.699,3.003v6.714h-4.237v-6.714c0-1.23-0.645-2.37-1.699-3.003c-1.056-0.638-2.367-0.667-3.448-0.092
		C3.154,54.646,0,59.889,0,65.63c0,4.288,1.729,8.277,4.798,11.196v43.138C1.732,122.883,0,126.87,0,131.156
		c0,5.742,3.154,10.985,8.229,13.682c1.082,0.575,2.396,0.541,3.452-0.089c1.054-0.633,1.699-1.772,1.699-3.005v-7.583h4.237v7.583
		c0,1.232,0.645,2.372,1.699,3.005c0.554,0.336,1.179,0.5,1.805,0.5c0.564,0,1.133-0.137,1.647-0.407
		c5.074-2.7,8.227-7.943,8.227-13.682c0-4.285-1.727-8.276-4.793-11.192v-7.818c2.305,1.763,5.13,2.873,8.229,2.966l34.435,7.715
		c0.418,0.094,0.89,0.074,1.36-0.027c5.828,0.736,11.589-2.233,14.353-7.332l3.27-5.849l15.16,34.888l-21.12,18.038
		c-0.775,0.564-1.515,1.181-2.187,1.858c-0.042,0.041-0.081,0.089-0.123,0.13c-3.26,3.36-5.049,7.778-5.049,12.453
		c0,2.646,6.812,29.037,11.419,46.568l-15.692,5.859c-0.851,0.318-1.545,0.955-1.937,1.772c-1.97,1.53-3.186,3.911-3.186,6.472
		c0,5.365,7.811,7.905,9.743,7.905c0.074,0,0.151,0,0.228-0.007l26.972,0.725c0.769,0.11,1.545,0.186,2.348,0.186
		c0.786,0,1.557-0.068,2.313-0.178h1.167c0.01,0,0.021,0,0.031,0c0.81-0.086,1.774-0.343,2.408-0.918
		c6.423-2.437,10.78-8.623,10.78-15.604c0-0.322-0.011-0.637-0.031-0.951c0.065-0.271,0.101-0.555,0.101-0.846
		c0-0.619-0.161-1.201-0.445-1.708c-0.264-1.225-0.669-2.426-1.216-3.586l-12.135-35.882c0.214-0.325,0.417-0.66,0.609-1.009
		l21.78-19.729l3.317,16.67c0.04,0.185,0.091,0.369,0.156,0.551c1.811,4.805,5.595,8.61,10.232,10.369l43.797,19.257v20.468
		c0,0.893,0.335,1.711,0.883,2.33c1.122,3.221,4.154,5.462,7.72,5.462c3.785,0,7.2-3.97,8.487-5.674
		c0.209-0.273,0.377-0.575,0.493-0.89l9.489-25.485c0.835-1.481,1.431-3.076,1.772-4.753l0.134-0.349
		c0.205-0.541,0.246-1.116,0.157-1.678c0.041-0.444,0.062-0.896,0.062-1.348c0-7.857-5.496-14.647-13.141-16.304l-37.692-16.844
		l-12.31-38.689c-0.044-0.144-0.099-0.28-0.16-0.417l-14.079-30.255l4.85,1.013l30.762,26.13c2.621,2.324,5.988,3.604,9.479,3.604
		c0.862,0,1.697-0.109,2.519-0.256l-14.593,14.596C170.752,144.933,170.752,147.151,172.121,148.52z M21.127,127.15H9.882
		c-0.851,0-1.632,0.305-2.242,0.812c0.57-1.396,1.516-2.634,2.779-3.586c0.876-0.663,1.391-1.696,1.391-2.796V75.214
		c0-1.1-0.515-2.134-1.391-2.796c-1.631-1.23-2.738-2.938-3.183-4.854c0.642,0.739,1.591,1.207,2.646,1.207h11.245
		c1.056,0,2.002-0.467,2.642-1.203c-0.445,1.913-1.552,3.621-3.181,4.851c-0.876,0.662-1.391,1.696-1.391,2.796v46.365
		c0,1.101,0.515,2.134,1.391,2.796c1.261,0.95,2.208,2.187,2.775,3.581C22.761,127.455,21.979,127.15,21.127,127.15z
		 M179.314,120.332l-31.497-26.76c-0.444-0.378-0.985-0.64-1.554-0.76l-12.566-2.625c-1.302-0.267-2.633,0.217-3.459,1.25
		c-0.823,1.037-0.993,2.454-0.436,3.655l16.93,36.39l12.714,39.969c0.301,0.948,0.999,1.731,1.909,2.139l39.484,17.638
		c0.243,0.117,0.507,0.195,0.773,0.243c4.556,0.869,7.864,4.863,7.864,9.504c0,0.451-0.048,0.89-0.105,1.327
		c-0.011,0.082-0.018,0.165-0.024,0.25c-0.021,0.065-0.034,0.134-0.041,0.202c-0.209,1.095-0.596,2.132-1.149,3.08
		c-0.106,0.178-0.195,0.362-0.264,0.554l-9.4,25.242c-0.962,1.178-2.27,2.368-2.608,2.519c-0.608,0-1.108-0.465-1.163-1.088
		c-0.048-0.507-0.195-0.979-0.432-1.396v-21.053c0-1.39-0.817-2.652-2.094-3.21l-46.049-20.239
		c-2.841-1.074-5.096-3.295-6.229-6.102l-4.312-21.645c0.123-1-0.268-2.02-0.948-2.8c-0.804-0.931-2.171-1.349-3.392-1.143
		c-0.023,0.007-0.357,0.055-0.381,0.058c-1.414,0.223-2.542,1.287-2.859,2.666l-25.172,22.806c-0.313,0.28-0.568,0.615-0.762,0.985
		c-0.371,0.722-0.806,1.383-1.292,1.971c-0.779,0.935-1.017,2.208-0.628,3.361l12.78,37.808c0.05,0.144,0.106,0.28,0.168,0.411
		c0.376,0.772,0.645,1.573,0.802,2.374c0.015,0.075,0.033,0.151,0.053,0.227c0.003,0.089,0.014,0.178,0.024,0.267
		c0.06,0.452,0.109,0.903,0.109,1.369c0,4.387-2.965,8.233-7.208,9.355c-0.154,0.041-0.301,0.097-0.445,0.158
		c-0.167,0-0.34,0.017-0.508,0.044c-0.991,0.151-2.043,0.151-3.034,0c-0.144-0.021-0.291-0.037-0.438-0.037l-27.411-0.746
		c-0.756-0.198-2.154-0.839-2.825-1.362c0.147-0.325,0.428-0.534,0.681-0.63c0.686-0.253,1.244-0.705,1.636-1.259l16.81-6.276
		c1.687-0.634,2.621-2.437,2.163-4.182c-4.497-17.066-11.733-45.193-11.995-47.846c0-2.871,1.114-5.589,3.144-7.648
		c0.014-0.014,0.027-0.027,0.044-0.041c0.397-0.397,0.838-0.76,1.497-1.249l23.313-19.907c1.17-0.999,1.554-2.648,0.939-4.065
		l-19.014-43.749c-0.53-1.224-1.711-2.04-3.039-2.103c-1.314-0.048-2.582,0.628-3.234,1.792l-6.743,12.062
		c-1.513,2.789-4.87,4.253-7.852,3.675c-0.347-0.07-0.732-0.055-1.126,0.014l-33.85-7.585c-0.253-0.057-0.508-0.084-0.769-0.084
		c-4.019,0-7.292-3.27-7.292-7.289c0-4.304,3.912-7.71,8.124-7.245c0.081,0.007,0.165,0.016,0.245,0.016
		c0.462,0.111,1.063,0.258,1.434,0.371l30.784,7.698c1.364,0.334,2.794-0.161,3.641-1.281l17.256-22.737
		c0.161-0.178,0.304-0.371,0.426-0.585c3.344-5.751,9.533-9.322,16.153-9.322c0.238,0,0.469,0.019,1.011,0.053
		c0.049,0.003,0.099,0.003,0.147,0.007c2.397,0.147,4.697,0.739,6.837,1.755c0.207,0.1,0.417,0.177,0.638,0.231l35.712,9.144
		c0.315,0.141,0.646,0.235,0.992,0.281c1.674,0.212,3.238,1.023,4.401,2.281c0.106,0.111,0.216,0.221,0.339,0.318l32.948,27.362
		c1.808,1.401,2.841,3.504,2.841,5.765c0,4.019-3.269,7.289-7.289,7.289C182.421,122.221,180.704,121.565,179.314,120.332z
		 M210.857,177.348l-16.354-16.357l17.466-17.467l0.705,0.705c0.685,0.684,1.581,1.02,2.479,1.02c0.896,0,1.796-0.343,2.484-1.027
		c1.365-1.368,1.365-3.586,0-4.955l-0.705-0.701l17.467-17.465l16.357,16.353L210.857,177.348z M219.446,106.15l9.996,9.995
		l-19.951,19.943l0,0c0,0,0,0,0,0.003l-19.94,19.944l-9.996-9.996L219.446,106.15z"/>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
